jQuery(document).on('ready', () => {
	if (window.matchMedia('(max-width: 1280px)').matches) {
		jQuery('.for-wechat').on('click mouseenter mouseleave', (e) => {
			if (jQuery(this).find('.qr-container').is(':visible')) {
				jQuery(this).find('.qr-container').css('display', 'none');
			} else {
				jQuery(this).find('.qr-container').css('display', 'block');
			}
			e.stopPropagation();
			e.preventDefault();
		});
	} else {
		jQuery('.for-wechat').on('click', (e) => {
			e.stopPropagation();
			e.preventDefault();
		});
		jQuery('.for-wechat').on({
			mouseenter(e) {
				jQuery(this).find('.qr-container').css('display', 'block');
				e.stopPropagation();
				e.preventDefault();
			},
			mouseleave(e) {
				jQuery(this).find('.qr-container').css('display', 'none');
				e.stopPropagation();
				e.preventDefault();
			},
		});
	}
	jQuery('.for-wechat .qr-container .qr-container-title span').on('click', () => {
		jQuery('a.for-wechat').trigger('click');
	});
});
